import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wpcm-wrapper" }
const _hoisted_2 = { class: "dialog-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`donation-style-${$props.dstyle} ${$setup.store.config.wrapper_class}`)
    }, [
      _createElementVNode("div", {
        class: "el-dialog__header",
        style: _normalizeStyle({backgroundImage: `url(${$setup.store.config.background_image})`})
      }, null, 4 /* STYLE */),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        ($setup.store.components || ($setup.store.use_form_builder && $setup.store.form_builder_config))
          ? (_openBlock(), _createBlock($setup["ModalTemplate"], {
              key: 0,
              config: $setup.store.config,
              currentStep: $setup.store.step
            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
              _renderList($setup.groupBySlots($setup.store.components), (slotData, slot) => {
                return {
                  name: `${slot}`,
                  fn: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotData, (comp) => {
                      return (_openBlock(), _createBlock($setup["ModalView"], { comp: comp }, null, 8 /* PROPS */, ["comp"]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                }
              })
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["config", "currentStep"]))
          : _createCommentVNode("v-if", true)
      ])), [
        [_directive_loading, $setup.store.loading]
      ])
    ], 2 /* CLASS */)
  ]))
}